const MENU_CODE = {
  HOME: 'HOME',
  ABOUT_US: 'ABOUT_US',
  EMPLOYEE: 'EMPLOYEE',
  PRODUCT: 'PRODUCT',
  PROMOTION: 'PROMOTION',
  ARTICLE: 'ARTICLE',
  GALLERY_REVIEW: 'GALLERY_REVIEW',
  CONTACT_US: 'CONTACT_US',
  GALLERY: 'GALLERY',
  VIDEO: 'VIDEO',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
}

const SECTION_CODE = {
  INTRODUCE: 'INTRODUCE',
  OVERVIEW_PRODUCT: 'OVERVIEW_PRODUCT',
  EXTRA_INFO: 'EXTRA_INFO',
  PROMOTION: 'PROMOTION',
  PRODUCT: 'PRODUCT',
  VIDEO: 'VIDEO',
  GALLERY: 'GALLERY',
  CLIENT: 'CLIENT',
  ARTICLE: 'ARTICLE',
  FAQ: 'FAQ',
}

export {
  MENU_CODE,
  SECTION_CODE,
}
